export default {
  "nav.home": "Hjem",
  "nav.products": "Produkter",
  "nav.guide": "Spreadsheet Guide",
  "nav.categories": "Kategorier",
  "nav.visitSite": "Besøg hovedwebstedet",

  "hero.badge": "Opdaterede ressourcer · Organiseret efter kategori",
  "hero.title": "AllChinaBuy-regneark",
  "hero.subtitle": "Find produkter, sælgere og købsressourcer i det nyeste AllChinaBuy-regneark — samlet ét enkelt sted.",
  "hero.ctaPrimary": "allchinabuy-regneark",
  "hero.ctaSecondary": "køb nu",

  "dropdown.label": "Vælg en kategori",
  "dropdown.placeholder": "Vælg en kategori…",

  "categories.title": "Udforsk produktkategorier",
  "categories.subtitle": "Gå direkte til den kategori, du leder efter, på hovedwebstedet.",

  "text.title": "Hvad er AllChinaBuy-regnearket?",
  "text.paragraph1": "AllChinaBuy-regnearket er en delt ressource, der samler produktlinks, sælgeroplysninger og kategorilister i én organiseret visning. I stedet for at gennemsøge utallige sider kan du bruge det som udgangspunkt for at opdage varer inden for mode, sneakers, streetwear, tasker og meget mere.",
  "text.paragraph2": "Dette websted er et uafhængigt informationshub. Vi organiserer kategorierne, så du hurtigt kan bevæge dig fra et emne til hovedwebstedet, hvor de fulde produktlister findes.",

  "articleLink.title": "Læs den fulde guide",
  "articleLink.subtitle": "Lær, hvordan du bruger AllChinaBuy-regnearket, hvad hver kategori indeholder, og hvordan du handler sikkert.",
  "articleLink.cta": "Læs guiden",

  "footer.disclaimer": "Dette er en uafhængig informationsressource. Produktlinks åbner på hovedwebstedet kaspreadsheet.com.",
  "footer.rights": "AllChinaBuy-regneark-hub.",

  "categories.shoes": "Sko",
  "categories.hoodies": "Hoodies/Sweatshirts",
  "categories.tshirts": "T-shirts",
  "categories.jackets": "Jakker",
  "categories.pants": "Bukser/Shorts",
  "categories.headwear": "Hovedbeklædning",
  "categories.sets": "Sæt",
  "categories.underwear": "undertøj",
  "categories.jersey": "Jersey",
  "categories.accessories": "Tilbehør",
  "categories.bags": "Tasker",
  "categories.belts": "Bælter",
  "categories.perfumes": "Parfumer",
  "categories.other": "Andet",

  "products.featuredTitle": "Udvalgte produkter",
  "products.featuredSubtitle": "Udforsk populære produkter fra AllChinaBuy spreadsheet. Klik for at se og købe på hovedwebstedet.",
  "products.viewAll": "Se alle produkter",

  "article.title": "AllChinaBuy-regneark-guide: produkter, kategorier og brug",
  "article.back": "Tilbage til forsiden",
  "article.published": "Opdateret",
  "article.intro": "AllChinaBuy-regnearket er en af de hurtigste måder at gennemse et bredt udvalg af produkter fra én organiseret ressource. I denne guide forklarer vi, hvad regnearket er, hvordan kategorierne er opbygget, og hvordan du kommer fra en kategori til de faktiske produktlister.",
  "article.h2.what": "Hvad er AllChinaBuy-regnearket?",
  "article.p.what": "AllChinaBuy-regnearket fungerer som en central reference for produkter og sælgere. Det grupperer varer i klare kategorier — sko, hoodies, t-shirts, jakker, bukser, hovedbeklædning, sæt, undertøj, jerseys, tilbehør, tasker, bælter, parfumer og mere — så du hurtigt kan finde den sektion, du har brug for.",
  "article.h2.categories": "Hvordan kategorierne er organiseret",
  "article.p.categories": "Hver kategori på dette websted linker direkte til den tilsvarende sektion på hovedwebstedet. Når du vælger en kategori, føres du direkte til listerne for den gruppe. Det holder oplevelsen enkel: vælg en kategori, åbn linket, og gennemse produkterne.",
  "article.h2.howto": "Sådan bruger du regnearket",
  "article.p.howto": "Start fra forsiden, vælg en kategori fra rullemenuen eller kategori-knapperne, og du føres til hovedwebstedet. Derfra kan du gennemse produktlisten, sammenligne sælgere og tjekke detaljer, før du beslutter dig.",
  "article.h2.safety": "Handl sikkert",
  "article.p.safety": "Tjek altid produktbeskrivelser, sælgervurderinger og forsendelsesdetaljer på hovedwebstedet, før du bestiller. Hold dine betalings- og kontooplysninger sikre, og kontrollér links, før du klikker.",
  "article.conclusion": "Klar til at udforske? Vend tilbage til forsiden for at gennemse kategorierne og åbne de fulde AllChinaBuy-regneark-lister.",
  "article.cta": "Tilbage til AllChinaBuy-regnearket",
};